import { apiGetRequest } from '../../../../utils/api/get';
import { StationListResponse } from '../../model/station';
import { BASE_URL } from '../../../../utils/auth';

export const fetchStationListAPI = (
  token: string,
  ownerId?: number
): Promise<StationListResponse> =>
  apiGetRequest<StationListResponse>({
    apiUrl: `${BASE_URL}/charging-stations`,
    token,
    params: ownerId !== undefined ? { owner_id: ownerId } : undefined,
  });
